// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NpsSurveyCard_npsWrapper__GAnrA .Polaris-Box {
    background: linear-gradient(to bottom, var(--p-color-bg-surface), var(--p-color-bg-surface-info-hover));
}

.NpsSurveyCard_ratingBox__9xLhi {
    padding-inline: var(--p-space-300);
}
`, "",{"version":3,"sources":["webpack://./src/common/NpsSurveyCard.module.css"],"names":[],"mappings":"AAAA;IACI,uGAAuG;AAC3G;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".npsWrapper :global(.Polaris-Box) {\n    background: linear-gradient(to bottom, var(--p-color-bg-surface), var(--p-color-bg-surface-info-hover));\n}\n\n.ratingBox {\n    padding-inline: var(--p-space-300);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"npsWrapper": `NpsSurveyCard_npsWrapper__GAnrA`,
	"ratingBox": `NpsSurveyCard_ratingBox__9xLhi`
};
export default ___CSS_LOADER_EXPORT___;
